/* eslint-disable @typescript-eslint/no-explicit-any */
import useGetLoanOfficers from '@/hooks/useGetLoanOfficers';
import { Dispatch, FC, SetStateAction } from 'react';
import EditRecordModal from './EditRecordModal';

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  agent: any;
  columns: string[];
}

const AgentFormModal: FC<Props> = ({ agent, isOpen, setIsOpen, columns }) => {
  const { data: loanOfficers } = useGetLoanOfficers();

  return (
    <EditRecordModal
      record={agent}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      columns={columns}
      selectField={{
        label: 'Loan Officer',
        placeholder: 'Select Loan Officer',
        fieldKey: 'loanOfficerId',
        items: loanOfficers?.map((o) => ({
          label: `${o.firstName} ${o.lastName}`,
          value: o._id,
        })),
        defaultValue: agent?.loanOfficerId || '',
      }}
      successMessage="Successfully Edited Agent"
    />
  );
};

export default AgentFormModal;
